import React, { useState } from "react";
import { makeStyles } from '@mui/styles';
import { AppBar, Toolbar, Typography, IconButton, Button } from '@mui/material';
import { Link } from "react-router-dom";



const useStyles = makeStyles(() => ({
    menuButton: {

    },
    title: {
        
        paddingRight: '40px',
        color: "orange",
        
        fontWeight: '100 !important',

    },

    customHeight: {
        //minHeight: 100
    },
    appLink: {
        textDecoration: "none",
        color: 'lightBlue',
        fontSize: 'medium'

    }
    

}));

export default function ButtonAppBar() {
    const classes = useStyles();
    const [example, setExample] = useState("primary");

    return (
        <React.Fragment>
            <AppBar className={classes.navbar}>
                <Toolbar >
                    <Typography variant='h4' className={classes.title}>Jude Woodland</Typography>
                    <Typography variant='h6' className={classes.title}>Fine Art and Reproductions</Typography>
                    <IconButton color="inherit">
                        <Link className={classes.appLink} to="/" >Home</Link>
                    </IconButton>
                    <IconButton color="inherit">
                        <Link className={classes.appLink} to="/gallery" >Gallery</Link>
                    </IconButton>
                    <IconButton color="inherit">
                        <Link className={classes.appLink} to="/about" >About Me</Link>
                    </IconButton>
                    <IconButton color="inherit">
                        <Link className={classes.appLink} to="/archive" >Archive</Link>
                    </IconButton>
                    <IconButton color="inherit">
                        <Link className={classes.appLink} to="/exhibitions" >Exhibitions</Link>
                    </IconButton>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
}






